var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-preview" }, [
    _c("div", { attrs: { id: "contents" } }, [
      _c("div", { staticClass: "inner clearfix detail-top" }, [
        _vm.photoClip.companyName
          ? _c(
              "p",
              {
                staticClass: "mt10 fll hd-type-01 company-name",
                attrs: { "data-test": "company-name" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.photoClip.companyName) + "\n      "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "clear" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm.photoClip.companyName
          ? _c("div", { staticClass: "company-area" }, [
              _c(
                "h1",
                {
                  staticClass: "fs16 hd-type-02 company-title option-title",
                  attrs: { "data-test": "photo-clip-title" },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.photoClip.companyName) +
                      "のフォトクリップ\n        "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "contents-inner clearfix mb30",
            attrs: { id: "photoclips" },
          },
          [
            _c("section", [
              _c(
                "article",
                { staticClass: "flex-container" },
                [
                  _vm._l(_vm.photoClip.photoInfoList, function (photoInfo, i) {
                    return [
                      _c(
                        "figure",
                        {
                          key: i,
                          staticClass: "photoclip",
                          style:
                            "background: url(" +
                            _vm.userImageUrlForPc +
                            "/top/bg_01.png) repeat left;",
                          attrs: { "data-test": "photo-clip-" + i },
                        },
                        [
                          photoInfo.image
                            ? _c("img", {
                                attrs: {
                                  src: _vm.getPhotoUrl(photoInfo.image),
                                  "data-test": "photo-" + i,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          photoInfo.caption
                            ? _c("figcaption", {
                                staticClass: "p15 pega-pre-wrap",
                                attrs: { "data-test": "caption-" + i },
                                domProps: {
                                  textContent: _vm._s(photoInfo.caption),
                                },
                              })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "mt30 fs13 detail-menu" }, [
      _c("a", [
        _c("li", { attrs: { "data-test": "tab-menu-job" } }, [
          _vm._v("募集情報"),
        ]),
      ]),
      _vm._v(" "),
      _c("span", [
        _c(
          "li",
          {
            staticClass: "active",
            attrs: { "data-test": "tab-menu-photo-clip" },
          },
          [_vm._v("フォトクリップ")]
        ),
      ]),
      _vm._v(" "),
      _c("a", [
        _c("li", { attrs: { "data-test": "tab-menu-interview" } }, [
          _vm._v("インタビュー記事"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }